/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import * as Icon from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import { getCountOrderStatusRecord } from "../../store/actions/orderAction";
import { removeLocalStorageAdmin } from "../../utils/Functions/removeLocalStorageAdmin";

const SellerHeaderContainer = () => {
  const dispatch = useDispatch();
  const getCountOrderStatusData = useSelector(
    (state) => state.orderReducer.getCountOrderStatusData,
  );

  const [statusNoArray, setStatusNoArray] = useState([0]);

  const allStatusInfo = (allStatusData, statusNo) => {
    if (!allStatusData) return;
    allStatusData.forEach((data) => {
      if (data.statusName === "Order Placed") {
        statusNo[0] = data.countStatus;
      }
    });
    setStatusNoArray([...statusNo]);
  };

  React.useEffect(() => {
    dispatch(getCountOrderStatusRecord());
    const data = getCountOrderStatusData?.data || [];
    allStatusInfo(data, [0]);
  }, []);

  React.useEffect(() => {
    const interval = setInterval(() => {
      dispatch(getCountOrderStatusRecord());
      const data = getCountOrderStatusData?.data || [];
      allStatusInfo(data, [0]);
    }, 1800000); // 30 minutes

    return () => clearInterval(interval);
  }, [getCountOrderStatusData]);

  return (
    <div id="wrapper" style={{ position: "fixed", top: "0", zIndex: "1000" }}>
      <div>
        <nav className="navbar navbar-default navbar-static-top m-b-0">
          <div className="navbar-header">
            <button
              className="navbar-toggle font-20 hidden-sm hidden-md hidden-lg"
              data-toggle="collapse"
              data-target=".navbar-collapse"
            >
              <i className="fa fa-bars"></i>
            </button>
            <div className="top-left-part">
              <Link className="logo" to="/SellerHome">
                <b>
                  <img
                    src="/favicon.ico"
                    alt="home"
                    style={{ width: "40px" }}
                  />
                </b>
                <span>
                  <img
                    src="/assets/plugins/images/sarawhite.png"
                    alt="homepage"
                    className="dark-logo"
                    style={{ width: "130px" }}
                  />
                </span>
              </Link>
            </div>
            <ul className="nav navbar-top-links navbar-left hidden-xs">
              <li>
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="sidebartoggler font-20 waves-effect waves-light"
                >
                  <i className="icon-arrow-left-circle"></i>
                </a>
              </li>
            </ul>

            {/* Right side */}
            <ul className="nav navbar-top-links navbar-right pull-right">
              <li
                style={{
                  backgroundColor: "#D71110",
                  borderRadius: "10px",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                <NavLink
                  to="/SellerLogin"
                  onClick={() => removeLocalStorageAdmin()}
                  style={{
                    lineHeight: "35px",
                    minHeight: "35px",
                    padding: "0 10px",
                  }}
                >
                  <span style={{ fontSize: "16px", color: "#fff" }}>
                    <i className="fa fa-power-off"></i>
                  </span>
                  <span
                    className="ml-5"
                    style={{
                      fontSize: "15px",
                      fontWeight: 700,
                      color: "#fff",
                    }}
                  >
                    Logout
                  </span>
                </NavLink>
              </li>
              <li className="dropdown">
                <Link to="/ManageOrder?status=order_placed">
                  <Icon.Bell className="text-light" />
                  <span className="badge badge-xs badge-danger">
                    {statusNoArray[0]}
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default SellerHeaderContainer;
